import { Button, IconButton } from "@mui/material";
import { ReactNode, useState } from "react";

type Prop = {
  icon: ReactNode;
  value?: ReactNode;
  onClick: () => void;
  isSelected: boolean;
};

export const DashboardMenuButton = ({ value, icon, onClick, isSelected }: Prop) => {
  const [buttonVariant, setButtonVariant] = useState<"contained">();
  if (!value)
    return (
      <IconButton size={"large"} color={isSelected ? "primary" : undefined}>
        {icon}
      </IconButton>
    );
  return (
    <Button
      startIcon={icon}
      variant={buttonVariant}
      fullWidth
      size={"large"}
      sx={{
        px: "15px",
        py: "12px",
        height: "48px",
        [`&:hover`]: {
          bgcolor: "primary.main",
        },
        justifyContent: "flex-start",
        ...(!buttonVariant ? { color: isSelected ? "palette.primary" : "text.primary" } : undefined),
      }}
      onClick={() => {
        onClick();
        setButtonVariant(undefined);
      }}
      onMouseOver={() => setButtonVariant("contained")}
      onMouseLeave={() => setButtonVariant(undefined)}
    >
      {value}
    </Button>
  );
};
